Wee.fn.make('extensions', {
	_construct: function() {
		var isDisabled = '-is-disabled',
			isActive = '-is-active';

		$.chain({
			'enable': function() {
				this.removeClass(isDisabled);

				return this;
			},
			'disable': function() {
				this.addClass(isDisabled);

				return this;
			},
			'isDisabled': function() {
				return this.hasClass(isDisabled);
			},
			'activate': function() {
				this.addClass(isActive);

				return this;
			},
			'deactivate': function() {
				this.removeClass(isActive);

				return this;
			},
			'isActive': function() {
				return this.hasClass(isActive);
			}
		});
	}
});